export default __webpack_public_path__ + "static/media/logo_est_polito_EC_noBackgroud.81fcb956.png";